var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.513,
    height: 49.994,
    viewBox: "0 0 62.513 49.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4641",
    "data-name": "Group 4641",
    transform: "translate(-67.25 -502.145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_flash",
    "data-name": "vuesax/outline/flash",
    transform: "translate(79.769 502.145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.54,44.8a2.588,2.588,0,0,1-1-.187c-.833-.312-2.25-1.333-2.25-4.562V26.61H4.416C1.625,26.61.625,25.3.271,24.527c-.354-.792-.667-2.4,1.167-4.5L17.206,2.113C19.331-.3,21.06-.136,21.893.176s2.25,1.333,2.25,4.562V18.174h4.874c2.791,0,3.791,1.312,4.145,2.083.354.792.667,2.4-1.167,4.5L16.227,42.671C14.748,44.358,13.456,44.8,12.54,44.8ZM20.747,3.113A6.845,6.845,0,0,0,19.56,4.2L3.791,22.111a2.286,2.286,0,0,0-.667,1.167,2.748,2.748,0,0,0,1.292.229h6.437a1.574,1.574,0,0,1,1.562,1.562v15a3.306,3.306,0,0,0,.271,1.625,6.846,6.846,0,0,0,1.187-1.083L29.642,22.694a2.286,2.286,0,0,0,.667-1.167,2.748,2.748,0,0,0-1.292-.229H22.58a1.574,1.574,0,0,1-1.562-1.562v-15A3.119,3.119,0,0,0,20.747,3.113Z",
    transform: "translate(8.27 2.594)",
    fill: "#ef7a30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H49.994V49.994H0Z",
    fill: "none",
    opacity: 0
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    x2: 13.257,
    transform: "translate(77.78 515.873)",
    fill: "none",
    stroke: "#ef7a30",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    x2: 11.931,
    transform: "translate(71.151 528.467)",
    fill: "none",
    stroke: "#ef7a30",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    x2: 22.677,
    transform: "translate(68.5 541.062)",
    fill: "none",
    stroke: "#ef7a30",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpress);
export default __webpack_public_path__ + "static/media/express.c9f276621fbde13ae8e347e0518133d0.svg";
export { ForwardRef as ReactComponent };